(() => {
  const popupSelector = 'popup-component[data-material-care-popup]';
  const openDialogSelector = 'dialog[open]:not([inert])';
  const closeButtonSelector = '[data-popup-close]';
  const motions = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setExpanded(details, expanded, instant) {
    const previous = motions.get(details);
    const group = previous?.group ?? details.getAttribute('name');
    const startHeight = details.getBoundingClientRect().height;
    previous?.animation?.cancel();
    details.removeAttribute('name');
    details.open = true;
    details.dataset.expanded = String(expanded);
    const state = { group, expanded, animation: null };
    motions.set(details, state);
    const finish = () => {
      if (motions.get(details) !== state) return;
      details.open = expanded;
      details.style.removeProperty('overflow');
      delete details.dataset.expanded;
      if (group !== null) details.setAttribute('name', group);
      motions.delete(details);
    };
    if (instant || !details.animate) {
      finish();
      return;
    }
    const summary = details.querySelector('summary');
    const endHeight = expanded
      ? details.getBoundingClientRect().height
      : summary.getBoundingClientRect().height + parseFloat(getComputedStyle(details).borderBottomWidth);
    details.style.overflow = 'hidden';
    state.animation = details.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: 200, easing: 'ease' }
    );
    state.animation.onfinish = finish;
  }

  document.addEventListener('click', event => {
    const summary = event.target.closest('summary.material-care-profile__summary');
    if (!summary || !summary.closest(popupSelector) || event.defaultPrevented) return;
    const details = summary.parentElement;
    const state = motions.get(details);
    const expanded = !(state?.expanded ?? details.open);
    const instant = event.detail === 0 || reducedMotion.matches;
    event.preventDefault();
    if (expanded) {
      details.closest('.material-care-profiles').querySelectorAll('details.material-care-profile').forEach(other => {
        if (other !== details && other.open) setExpanded(other, false, instant);
      });
    }
    setExpanded(details, expanded, instant);
  });

  reducedMotion.addEventListener('change', event => {
    if (!event.matches) return;
    document.querySelectorAll(`${popupSelector} details.material-care-profile`).forEach(details => {
      const state = motions.get(details);
      if (state) setExpanded(details, state.expanded, true);
    });
  });

  function closeOpenMaterialCareDrawer() {
    const popup = document.querySelector(`${popupSelector} ${openDialogSelector}`)?.closest(popupSelector);

    if (!popup) {
      return;
    }

    const closeButton = popup.querySelector(closeButtonSelector);

    if (closeButton) {
      closeButton.click();
      return;
    }

    const dialog = popup.querySelector('dialog[open]');

    if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  }

  document.addEventListener('theme:product:added', closeOpenMaterialCareDrawer);
})();
